export default {
  data() {
    return {
      economicModel: {
        id: null,
        year: new Date().getFullYear(),
        cos: 0,
        team_member: 0,
        net_profit_goal: 0,
        avg_sale_price: 0,
        avg_commission_percent: 0,
        listings_taken_percent: 0,
        listings_taken_to_close: 0,
        percent_of_business: 0,
        buyers_taken_percent: 0,
        buyers_taken_to_close: 0,
        seasonality_q1: 20,
        seasonality_q2: 30,
        seasonality_q3: 30,
        seasonality_q4: 20
      },
      cos: {
        id: null,
        year: new Date().getFullYear(),
        team_member: 0,
        monthly_expenses: 0,
        broker_percent: 0,
        broker_yearly_max: true,
        broker_dollar_max: 0,
        franchise_fee: false,
        annual_franchise_fee: 0,
        listings_sold: 0,
        buyers_sold: 0,
        listings_commission_percent: 0,
        buyers_commission_percent: 0,
        isa: false,
        isa_percent_total: 0,
        isa_percent: 0,
        referral_fee_count: 0,
        referral_fee_percent: 0,
        transaction_fee: false,
        transaction_fee_amount: 0,
        buyer_transaction_fee: false,
        buyer_transaction_fee_amount: 0,
        additional_cos: 0
      }
    }
  },
  computed: {
    avgSalePrice() {
      return this.economicModel.avg_sale_price;
    },
    averageCommission() {
      return Number(this.economicModel.avg_sale_price) * (Number(this.economicModel.avg_commission_percent) / 100);
    },
    closedUnits() {
      return Math.round(this.companyGci / this.averageCommission);
    },
    closedSalesVolume() {
      return this.closedUnits * this.economicModel.avg_sale_price;
    },
    companyGci() {
      return Number(this.economicModel.net_profit_goal) + this.yearlyExpenses + Number(this.economicModel.cos);
    },
    grossProfit() {
      return this.companyGci - Number(this.calculatedCos);
    },
    profitPercent() {
      return (100 - this.expensePercent - this.cosPercent).toFixed(2);
    },
    calculatedCos() {
      let cos = (Number(this.paidToBroker) + 
          Number(this.cos.annual_franchise_fee)) + 
          Number(this.teamListingsGci) + 
          Number(this.teamBuyersGci) + 
          Number(this.calculatedIsa) + 
          Number(this.referralFees) + 
          Number(this.adminFees) + 
          Number(this.cos.additional_cos);
      return cos ? cos : 0;
    },
    totalApptsHeld() {
      return (this.totalListingsTaken / (Number(this.economicModel.listings_taken_percent) / 100)).toFixed();
    },
    totalListingsTaken() {
      return (this.totalListingsSold / (Number(this.economicModel.listings_taken_to_close) / 100)).toFixed();
    },
    totalListingsSold() {
      return (this.closedUnits * (Number(this.economicModel.percent_of_business) / 100)).toFixed();
    },
    totalBuyersHeld() {
      return (this.totalBuyersTaken / (Number(this.economicModel.buyers_taken_percent) / 100)).toFixed();
    },
    totalBuyersTaken() {
      return (this.totalBuyersSold / (Number(this.economicModel.buyers_taken_to_close) / 100)).toFixed();
    }, 
    totalBuyersSold() {
      return (this.closedUnits * ((100 - Number(this.economicModel.percent_of_business)) / 100)).toFixed();
    },
    expensePercent() {
      return (this.yearlyExpenses / this.companyGci * 100).toFixed(2);
    },
    cosPercent() {
      return (this.calculatedCos / this.companyGci * 100).toFixed(2);
    },
    totalSeasonality() {
      return Number(this.economicModel.seasonality_q1) + Number(this.economicModel.seasonality_q2) + Number(this.economicModel.seasonality_q3) + Number(this.economicModel.seasonality_q4);
    },
    listingsSold() {
      return this.totalListingsSold - Number(this.cos.listings_sold);
    },
    buyersSold() {
      return this.totalBuyersSold - Number(this.cos.buyers_sold);
    },
    paidToBroker() {
      if(this.cos.broker_yearly_max) {
        return Number(this.cos.broker_dollar_max);
      } else {
        return this.companyGci * (Number(this.cos.broker_percent) / 100);
      }
    },
    teamListings() {
      if(this.cos.team_member == 0) {
        return Number(this.listingsSold) * Number(this.averageCommission) * (Number(this.cos.listings_commission_percent) / 100);
      } else if(this.cos.team_member == 1) {
        return Number(this.totalListingsSold) * Number(this.averageCommission) * (Number(100 - this.cos.listings_commission_percent) / 100);
      } else {
        return 0;
      }
    },
    teamBuyers() {
      if(this.cos.team_member == 0) {
        return Number(this.buyersSold) * Number(this.averageCommission) * (Number(this.cos.buyers_commission_percent) / 100);
      } else if(this.cos.team_member == 1) {
        return Number(this.totalBuyersSold) * Number(this.averageCommission) * (Number(100 - this.cos.buyers_commission_percent) / 100);
      } else {
        return 0;
      }
    },
    isaTotal() {
      return this.closedUnits * (Number(this.cos.isa_percent_total) / 100);
    },
    isaComp() {
      return this.averageCommission * (Number(this.cos.isa_percent) / 100);
    },
    calculatedIsa() {
      return Math.round(this.isaTotal * this.isaComp);
    },
    teamListingsGci() {
      return this.teamListings;
    },
    teamBuyersGci() {
      return this.teamBuyers;
    },
    referralFees() {
      return Number(this.averageCommission) * (Number(this.cos.referral_fee_percent) / 100) * Number(this.cos.referral_fee_count);
    },
    listingAdminFees() {
      if(this.cos.transaction_fee) {
        return Number(this.totalListingsSold) * Number(this.cos.transaction_fee_amount);
      } else {
        return 0;
      }
    },
    buyerAdminFees() {
      if(this.cos.buyer_transaction_fee == 1) {
        return Number(this.totalBuyersSold) * Number(this.cos.buyer_transaction_fee_amount);
      } else {
        return 0;
      }
    },
    adminFees() {
      return this.listingAdminFees + this.buyerAdminFees;
    },
    yearlyExpenses() {
      return this.cos.monthly_expenses * 12;
    }
  }
};